import type { Group, Question } from '@api/instant_survey/types';

export const getDropdownOptions = (items: Item[]) => {
  return items.map((item, index) => {
    const isQuotaGroup = 'name' in item;
    return {
      label: isQuotaGroup ? item.name : getQuestionDropdownLabel({ index, question: item }),
      value: item.id,
    };
  });
};

export const getIsPreviewDisabled = (questions?: Question[]) => !questions?.length;

const getQuestionDropdownLabel = ({ index, question }: { index: number; question: Question }) => {
  return `${index + 1}. ${question.text}`;
};

export type Item = Group | Question;

export interface PreviewSelection {
  questionId?: number;
  quotaGroupId?: number;
  /**
   * Monotonic counter used to force a new preview session when restarting from the
   * same question and quota group selection.
   */
  restartKey?: number;
}
